import { Component } from '@angular/core';
import { CustomerType } from 'src/app/enums/customer-type';
import { IWizard } from 'src/app/interfaces/iwizard';
import { WizardSteps } from 'src/app/interfaces/wizard-steps';
import { EnrollmentService } from 'src/app/services/enrollment.service';
import { GeneralService } from 'src/app/services/general.service';

@Component({
    selector: 'app-c-start-isp',
    templateUrl: './c-start-isp.component.html',
    styleUrls: ['./c-start-isp.component.scss'],
    standalone: false
})
export class CStartISPComponent {
     wizardObj: IWizard = {
          steps: [
                  {step:1, text:'Welcome'} as WizardSteps,
                  {step:2, text:'Company Information'} as WizardSteps,
                  {step:3, text:'User Accounts'} as WizardSteps,
                  {step:4, text:'Review'} as WizardSteps,
                  {step:5, text:'Contract Documents'} as WizardSteps,
                  {step:6, text:'Submit'} as WizardSteps,
                  {step:7, text:'Billing Information'} as WizardSteps
                  ]
      }

     constructor(public generalService:GeneralService, public enrollment:EnrollmentService){
          this.enrollment.newCustomer!.customerType = CustomerType.ISP;

     }

     scrollToTop() {
          window.scrollTo(0, 0);
      }

     ngOnInit(){
          setTimeout(() => this.scrollToTop(), 500);
     }

     openDocument(docName: string) {
          this.generalService.openDocument(docName);
      }
}
